import React from 'react'

import * as S from './styles'

export function Loading({ size, color, ...rest }) {
    // O resto (ex.: `style`) é repassado pro elemento real - é o jeito de um
    // uso inline (ex.: dentro de um botão pequeno) zerar os margin/margin-top
    // padrão do spinner, feitos pra um loading de página/seção inteira.
    return (
        <S.Loading size={size} color={color} {...rest} />
    )
}